__webpack_require__.p = "/StockChart/";